import { ref, watchEffect } from 'vue'
import { useForgotPasswordMutation } from '@server/graphql/mutations/forgotPasswordMutation'
import { IForgotPasswordInput, IForgotPasswordData, IFetchForgotPasswordReturn } from '@types'

/**
 * Função para executar a mutação de esqueci a senha.
 * @param forgotPasswordInput As variáveis necessárias para a mutação.
 * @returns Um objeto com referências reativas para os dados, estado de carregamento, erros e função de parada.
 */
const mutateForgotPassword = (
  forgotPasswordInput: IForgotPasswordInput
): IFetchForgotPasswordReturn => {
  const data = ref<IForgotPasswordData | null>(null)
  const loading = ref<boolean>(false)
  const error = ref<Error | null>(null)
  const { mutate, onDone, onError } = useForgotPasswordMutation()

  const execute = async () => {
    loading.value = true
    try {
      await mutate({ forgotPasswordInput })
    } catch (err) {
      error.value = err as Error
    }
  }

  const stop = watchEffect(() => {
    onDone(({ data: mutationData }) => {
      data.value = mutationData?.forgotPassword.payload.message
      loading.value = false
    })

    onError(mutationError => {
      error.value = mutationError.graphQLErrors[0]
      loading.value = false
    })
  })

  return { execute, data, loading, error, stop }
}

export default mutateForgotPassword
